export function GenerateIcon() {
    return (
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_i_479_10411)">
                <g clipPath="url(#clip0_479_10411)">
                    <rect width="38" height="38" rx="19" fill="url(#paint0_linear_479_10411)" fillOpacity="0.88" />
                    <g filter="url(#filter1_f_479_10411)">
                        <path
                            d="M24.2228 19.7917C32.042 19.7917 35.917 23.3034 35.917 30.2566C35.917 37.2097 32.042 40.7917 24.292 40.7917C16.542 40.7917 12.667 37.28 12.667 30.3268C12.667 23.3736 16.542 19.7917 24.2228 19.7917Z"
                            fill="url(#paint1_linear_479_10411)"
                        />
                    </g>
                    <g filter="url(#filter2_d_479_10411)">
                        <path
                            d="M19.2941 8.50159C27.1133 8.50159 30.9883 12.0133 30.9883 18.9665C30.9883 25.9196 27.1133 29.5016 19.3633 29.5016C18.6043 29.5016 17.8824 29.4679 17.1977 29.4006C16.3046 29.3128 13.3799 31.5786 12.6133 31.3766C11.7003 31.136 12.9719 28.4037 12.2383 28.0015C9.23828 26.3567 7.73828 23.3628 7.73828 19.0367C7.73828 12.0835 11.6133 8.50159 19.2941 8.50159Z"
                            fill="white"
                        />
                    </g>
                    <path
                        d="M15.8796 15.5912C16.6293 15.5912 17.0042 15.9661 17.0042 16.7159V17.8406C17.0042 18.5904 16.6293 18.9653 15.8796 18.9653C15.1298 18.9653 14.7549 18.5904 14.7549 17.8406V16.7159C14.7549 15.9661 15.1298 15.5912 15.8796 15.5912Z"
                        fill="black"
                    />
                    <path
                        d="M22.6188 15.5912C23.3686 15.5912 23.7435 15.9661 23.7435 16.7159V17.8406C23.7435 18.5904 23.3686 18.9653 22.6188 18.9653C21.869 18.9653 21.4941 18.5904 21.4941 17.8406V16.7159C21.4941 15.9661 21.869 15.5912 22.6188 15.5912Z"
                        fill="black"
                    />
                    <path
                        d="M22.3 21.37C22.3909 21.3065 22.4933 21.2615 22.6015 21.2376C22.7098 21.2137 22.8216 21.2113 22.9308 21.2306C23.0399 21.25 23.1442 21.2906 23.2376 21.3502C23.331 21.4098 23.4118 21.4872 23.4753 21.5781C23.5388 21.6689 23.5838 21.7714 23.6077 21.8796C23.6317 21.9878 23.634 22.0997 23.6147 22.2088C23.5954 22.318 23.5548 22.4222 23.4951 22.5156C23.4355 22.6091 23.3581 22.6899 23.2673 22.7534C22.0897 23.5766 20.7457 23.9905 19.2612 23.9905C17.7755 23.9905 16.4315 23.5766 15.2539 22.7534C15.1631 22.6899 15.0857 22.6091 15.026 22.5156C14.9664 22.4222 14.9258 22.318 14.9065 22.2088C14.8872 22.0997 14.8895 21.9878 14.9134 21.8796C14.9373 21.7714 14.9823 21.6689 15.0459 21.5781C15.1094 21.4872 15.1901 21.4098 15.2836 21.3502C15.377 21.2906 15.4813 21.25 15.5904 21.2306C15.6995 21.2113 15.8114 21.2137 15.9196 21.2376C16.0279 21.2615 16.1303 21.3065 16.2211 21.37C17.1119 21.9942 18.1174 22.3035 19.2612 22.3035C20.4038 22.3035 21.4093 21.9942 22.3 21.37Z"
                        fill="black"
                    />
                </g>
            </g>
            <defs>
                <filter id="filter0_i_479_10411" x="0" y="0" width="38" height="38" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="6.33333" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_479_10411" />
                </filter>
                <filter
                    id="filter1_f_479_10411"
                    x="-0.316339"
                    y="6.80836"
                    width="49.2167"
                    height="46.9667"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="6.49167" result="effect1_foregroundBlur_479_10411" />
                </filter>
                <filter
                    id="filter2_d_479_10411"
                    x="-3.34505"
                    y="-2.58175"
                    width="45.4167"
                    height="45.0544"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="5.54167" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_479_10411" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_479_10411" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_479_10411" x1="27.7083" y1="34.8333" x2="19" y2="1.04622e-06" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#8000FF" />
                    <stop offset="1" stopColor="#006AFF" />
                </linearGradient>
                <linearGradient id="paint1_linear_479_10411" x1="26.5212" y1="17.8125" x2="29.6878" y2="44.7292" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#9500FF" />
                    <stop offset="1" stopColor="#FFB700" />
                </linearGradient>
                <clipPath id="clip0_479_10411">
                    <rect width="38" height="38" rx="19" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
